export function formatToMySQLDateTime(value: Date | string): string {
    return value instanceof Date ? value.toISOString().slice(0, 19).replace("T", " ") : value
}
